export const ru = {
    cancel: 'Отмена',
    'no-creatives': 'Нет архивных креативов',
    view: 'Посмотреть'
};
